import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../../styles/login.css";
import Header from "../../pages/homepage/Header";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function DriverSignup() {
  // Hook to navigate
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    vehicleRegistrationNo: "",
    drivingLicenseNo: "",
    userType: "user",
  });

  // Function to handle changes in input fields
  const handleChange = async (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if all fields are filled
    for (const key in formData) {
      if (formData[key] === "") {
        toast.warn("Please fill in all fields!", {
          position: "top-left",
          autoClose: 2000,
          theme: "dark",
        });

        navigate("/driver/signup");
        return;
      }
    }

    localStorage.setItem("user", JSON.stringify(formData));
    try {
      // Send a POST request to the server with form data
      let result = await fetch("http://localhost:8000/driver", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Parse the response as JSON
      result = await result.json();

      // If successful, save user data in local storage and navigate to dashboard
      if (result) {
        localStorage.clear();
        navigate("/");
      }
    } catch (error) {
      localStorage.clear();
      console.error("Error during fetch operation:", error);
    }
  };

  return (
    <div>
      <Header />

      {/* Sign-up Form */}
      <section>
        <div className="container mt-1 pt-1">
          <div className="row">
            <div className="col-12 col-sm-7 col-md-6 m-auto">
              <div className="card border-0 shadow custom-card">
                <div className="card-body p-4  text-light">
                  {/* User Icon */}
                  <div className="d-flex justify-content-center mt-4 mb-4">
                    <i className="fa-solid fa-user"></i>
                  </div>

                  {/* Input fields for user information */}
                  <form onSubmit={handleSubmit}>
                    <input
                      type="text"
                      className="form-control mt-2"
                      placeholder="Name"
                      aria-label="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />

                    <input
                      type="email"
                      name="email"
                      id="email"
                      className="form-control col mt-2"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                    />

                    <input
                      type="password"
                      id="password"
                      className="form-control mt-2"
                      placeholder="Password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                    />

                    <input
                      type="text"
                      className="form-control mt-2"
                      placeholder="Phone"
                      aria-label="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />

                    <input
                      type="text"
                      className="form-control mt-2"
                      placeholder="Vehicle Registration No"
                      aria-label="police id"
                      name="vehicleRegistrationNo"
                      value={formData.vehicleRegistrationNo}
                      onChange={handleChange}
                    />

                    <input
                      type="text"
                      className="form-control mt-2"
                      placeholder="Driving License No"
                      aria-label="police badge no"
                      name="drivingLicenseNo"
                      value={formData.drivingLicenseNo}
                      onChange={handleChange}
                    />

                    {/* Checkbox for agreeing to terms and conditions */}
                    <div className="col-12 mt-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="gridCheck"
                          required
                        />
                        <label className="form-check-label" htmlFor="gridCheck">
                          I Agree to
                          <NavLink
                            className="text-light"
                            to="/terms"
                            target="_blank"
                          >
                            Terms and Conditions
                          </NavLink>
                        </label>
                      </div>
                    </div>

                    <div className="text-center mt-4">
                      <button
                        type="submit"
                        className="btn btn-outline-light w-100"
                      >
                        Submit
                      </button>
                      <p className="p-2">
                        Already have an Account?
                        <br />
                        <NavLink
                          className="btn text-light"
                          type="button"
                          to="/driver/login"
                        >
                          Login
                        </NavLink>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
}

export default DriverSignup;
